import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f3525928")

_pushScopeId("data-v-f3525928")
const _hoisted_1 = { class: "nav-horizontal-content" }
const _hoisted_2 = { class: "nav-horizontal-main" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "logOut" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "space" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.showLogo)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "icon-content",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickLogo && _ctx.clickLogo(...args)))
        }, [
          _createVNode("img", {
            class: "logo-img",
            src: _ctx.logoMap.navBarLogo
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("section", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", {
          class: "logout",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
        }, _toDisplayString(_ctx.$wordList.NavInHtmlMenuLogOut), 1)
      ])
    ])
  ]))
})